/* Dawterson homepage: reinforce lazy loading below the first homepage modules on mobile only. */
(() => {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  const apply = () => {
    if (!document.body.classList.contains('template-index') && !document.querySelector('.daw-why')) return;
    const main = document.querySelector('#MainContent');
    if (!main) return;
    const sections = [...main.querySelectorAll('.shopify-section')];
    sections.slice(2).forEach(section => {
      section.querySelectorAll('img').forEach(img => {
        img.loading = 'lazy';
        img.decoding = 'async';
        if (!img.fetchPriority || img.fetchPriority === 'auto') img.fetchPriority = 'low';
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, {once:true}); else apply();
})();
